//@flow
import type { ReducerState$Type,EditFormData } from './flowTypes'

export const transformDataToEditFormData=(data:any,hermes: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const hermesResultsetData = data['hermesResultset']
    formData.isInvalidDoc = hermesResultsetData['is_invalid_doc']?hermesResultsetData['is_invalid_doc']:false
    formData.isOverrideInvTotal = hermesResultsetData['is_override_inv_total']?hermesResultsetData['is_override_inv_total']:false
    formData.isOverrideVendorName = hermesResultsetData['is_override_vendor_name']?hermesResultsetData['is_override_vendor_name']:false
    formData.isOverrideAdditionalNotfound = hermesResultsetData['is_override_additional_notfound']?hermesResultsetData['is_override_additional_notfound']:false
    formData.isOverrideTaxNotfound = hermesResultsetData['is_override_tax_notfound']?hermesResultsetData['is_override_tax_notfound']:false

    if (hermesResultsetData['inv_no']){
        formData.invNo = hermesResultsetData['inv_no']
    }
    if (hermesResultsetData['inv_date']){
        formData.invDate = hermesResultsetData['inv_date']
    }
    if (hermesResultsetData['po_no']){
        formData.poNo = hermesResultsetData['po_no']
    }
    if (hermesResultsetData['inv_total']){
        formData.invTotal = parseFloat(hermesResultsetData['inv_total'])
    }
    if (hermesResultsetData['vendor_name']){
        formData.vendorName = hermesResultsetData['vendor_name']
    }
    if (hermesResultsetData['sub_total']){
        formData.subTotal = parseFloat(hermesResultsetData['sub_total'])
    }
    
    formData.tax = hermesResultsetData['tax']?parseFloat(hermesResultsetData['tax']):0
    formData.additional = hermesResultsetData['additional']?parseFloat(hermesResultsetData['additional']):0
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/hermes/editFormData.js